import dayjs from "dayjs";

/**
 * Today's date in the format <Input type="date"> expects (YYYY-MM-DD).
 *
 * Form date fields carry short ISO strings, so a lexicographic comparison
 * ("2026-08-05" >= "2026-08-04") is equivalent to a chronological one: no
 * need to convert to a Date object.
 */
export const todayIso = () => dayjs().format("YYYY-MM-DD");

/**
 * Today + n days, same format. Useful for the `min` attribute of date fields
 * when a minimum lead time is required.
 */
export const isoInDays = (days) => dayjs().add(days, "day").format("YYYY-MM-DD");
